import tracking from '@finn-no/analytics';
import { TrackingData } from '../../components/types';
import { RecommendationData } from '../../../types/recommendation';

export function trackRecommendationNotFound (data: RecommendationData, options: TrackingData) {
    tracking.trackEvent({
        ecType: 'USER',
        ecCategory: 'recommendationEvents',
        eventData: {
            'version': data.version,
            'recsys.position': `recommend.${options.channel}_${options.position}.empty`,
        },
    });
}

export function trackShow (data: RecommendationData, options: TrackingData) {
    if (data.items) {
        const adids = data.items.map(item => item.itemId);

        tracking.trackEvent({
            ecType: 'USER',
            ecCategory: 'recommendationEvents',
            eventData: {
                'adIds': adids.join(','),
                'recsys.uuid': data.uuid,
                'recsys.position': `recommend.${options.channel}_${options.position}.show`,
            },
        });
    }
}

export function trackClickRecommendation (ev: Event, options: TrackingData) {
    const finncode = this.getAttribute('data-finn-adid');
    const uuid = this.getAttribute('data-finn-recommend-uuid');

    tracking.trackEvent({
        ecType: 'USER',
        ecCategory: 'recommendationEvents',
        eventData: {
            finncode,
            'recsys.uuid': uuid,
            'recsys.position': `recommend.${options.channel}_${options.position}.click`,
        },
        analyticsName: 'promotions.distribution-recommendation.click',
        stringValue: `channel:${options.channel}, distribution:${options.distribution}, position:${options.position}`,
        context: { referrer: `http://www.finn-recommendation.no/synthesised-referrer/${options.channel}` },
    });
}
